import { createRouteRef } from '@backstage/core-plugin-api';

const azurePullRequestDashboardRouteRef = createRouteRef({
  id: "azure-pull-request-dashboard"
});
const azurePipelinesEntityContentRouteRef = createRouteRef({
  id: "azure-pipelines-entity-content"
});
const azureGitTagsEntityContentRouteRef = createRouteRef({
  id: "azure-git-tags-entity-content"
});
const azurePullRequestsEntityContentRouteRef = createRouteRef({
  id: "azure-pull-requests-entity-content"
});

export { azureGitTagsEntityContentRouteRef, azurePipelinesEntityContentRouteRef, azurePullRequestDashboardRouteRef, azurePullRequestsEntityContentRouteRef };
//# sourceMappingURL=routes.esm.js.map
